import type { HttpErrorDetails } from './getHttpErrorDetails';

/** A failed HTTP response, before its body is interpreted as GraphQL. */
export class RelayHttpError extends Error {
	readonly statusCode: number;
	readonly traceId: string | undefined;
	readonly originalResponse: Response;

	constructor({ statusCode, message, traceId, originalResponse }: HttpErrorDetails) {
		super(message);
		this.name = 'RelayHttpError';
		this.statusCode = statusCode;
		this.traceId = traceId;
		this.originalResponse = originalResponse;
	}
}
